import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

function formatScoreNumber(value) {
  if (!Number.isFinite(Number(value))) return "-";
  const n = Number(value);
  if (Number.isInteger(n)) return String(n);
  return String(Math.round(n * 100) / 100);
}

function scoreTone(awarded, max) {
  if (Number.isFinite(awarded) && Number.isFinite(max) && max > 0) {
    if (awarded >= max) return "correct";
    if (awarded <= 0) return "incorrect";
    return awarded / max >= 0.5 ? "partial" : "incorrect";
  }
  return "partial";
}

const TONE = {
  correct: { bar: "#D4F0E1", accent: "#1F9D73", score: "#148F77" },
  partial: { bar: "#FDE6C4", accent: "#E67E22", score: "#D35400" },
  incorrect: { bar: "#F8D7D7", accent: "#C0392B", score: "#C0392B" },
};

const ExamResultsCover = ({ studentName, examName, awarded, max, hideScore = false }) => {
  const awardedNum = Number(awarded);
  const maxNum = Number(max);
  const colors = TONE[scoreTone(awardedNum, maxNum)];
  const scoreLabel = `${formatScoreNumber(awardedNum)} / ${formatScoreNumber(maxNum)}`;

  return (
    <Flex
      direction="column"
      w="100%"
      h="100%"
      bg="#F7FAFC"
      userSelect="none"
      pointerEvents="none"
    >
      <Flex
        align="center"
        justify="center"
        bg="#0E3D59"
        color="white"
        h="24%"
        flexShrink={0}
        px={6}
      >
        <Text fontWeight="900" fontSize={{ base: "2xl", md: "3xl" }} letterSpacing="0.04em">
          Report
        </Text>
      </Flex>
      <Box h="6px" bg="#1F9D73" flexShrink={0} />
      <Flex direction="column" align="center" justify="center" flex="1" px={8} py={8} gap={8}>
        <Box textAlign="center">
          <Text
            fontSize="xs"
            fontWeight="800"
            letterSpacing="0.14em"
            color="#73808C"
            mb={2}
          >
            STUDENT
          </Text>
          <Text fontWeight="900" fontSize={{ base: "xl", md: "2xl" }} color="#1F2E40">
            {studentName || "Student"}
          </Text>
        </Box>
        {examName ? (
          <Box textAlign="center">
            <Text fontWeight="800" fontSize={{ base: "md", md: "lg" }} color="#1F2E40">
              {examName}
            </Text>
          </Box>
        ) : null}
        {hideScore ? null : (
          <Box
            w="min(340px, 80%)"
            bg={colors.bar}
            borderLeft="8px solid"
            borderLeftColor={colors.accent}
            px={6}
            py={5}
            textAlign="center"
          >
            <Text fontSize="xs" fontWeight="800" letterSpacing="0.14em" color="#73808C" mb={2}>
              SCORE
            </Text>
            <Text fontWeight="900" fontSize="3xl" color={colors.score} lineHeight="1.1">
              {scoreLabel}
            </Text>
          </Box>
        )}
      </Flex>
    </Flex>
  );
};

export default ExamResultsCover;
